module.exports = __webpack_public_path__ + "static/img/m7.4ce72f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m7.png
// module id = 5+Yi
// module chunks = 12